@if (loading()) {
  <app-loading></app-loading>
}@else {
  <app-header 
    [icon]="'arrow_back_ios'"
    (iconClickedEvent)="back()">
  </app-header>
  <div class="container">
    <div class="sub-title">{{ 'choose_a_plan.title' | translate }}</div>

    <div class="plan">
      <img src="imgs/neutral.png" alt="">
      <p class="plan-title">{{ 'choose_a_plan.free_tier' | translate }}</p>    
      <span class="plan-desc">{{ 'choose_a_plan.free_tier_desc' | translate }}</span>
      <div>
        <div class="plan-info">
          <ul>
            <li>{{ 'choose_a_plan.free_feature_1' | translate }}</li>
            <li>{{ 'choose_a_plan.free_feature_2' | translate }}</li>
            <li>{{ 'choose_a_plan.free_feature_3' | translate }}</li>
          </ul>
          <div class="price-container">
            <span class="price">0</span>
            <div class="cents-container">
              <span class="cents">.00 €</span>
              <span class="frequency">/{{ 'choose_a_plan.month' | translate }}</span>
            </div>          
          </div>     
        </div>
      </div>
      <app-button
        [buttonType]="BUTTON_TYPES.OUTLINED" 
        [buttonLabel]="'buttons.starter' | translate"
        (click)="choosePlan(PLANS.STARTER.code)"
      ></app-button>
    </div>

    <div class="plan">
      <img src="imgs/super-positive.png" alt="">
      <p class="plan-title">{{ 'choose_a_plan.professional_tier' | translate }}</p>        
      <span class="plan-desc">{{ 'choose_a_plan.professional_tier_desc' | translate }}</span>
      <div>
        <div class="plan-info">
          <ul>
            <li>{{ 'choose_a_plan.professional_feature_1' | translate }}</li>
            <li>{{ 'choose_a_plan.professional_feature_2' | translate }}</li>
            <li>{{ 'choose_a_plan.professional_feature_3' | translate }}</li>
            <li>{{ 'choose_a_plan.professional_feature_4' | translate }}</li>
            <li>{{ 'choose_a_plan.professional_feature_5' | translate }}</li>
            <li>{{ 'choose_a_plan.professional_feature_6' | translate }}</li>
            <li>{{ 'choose_a_plan.professional_feature_7' | translate }}</li>
          </ul> 
          <div class="price-container">
            @if(this.psychologistService.psychologist()?.vip) {
              <span class="price">0</span>
              <div class="cents-container">
                <span class="cents">.00 €</span>
                <span class="frequency">/{{ 'choose_a_plan.month' | translate }}</span>
              </div>              
            }@else {
              <span class="price">12</span>
              <div class="cents-container">
                <span class="cents">.90 €</span>
                <span class="frequency">/{{ 'choose_a_plan.month' | translate }}</span>
              </div>
            }
          </div>
          @if(this.psychologistService.psychologist()?.vip) {
            <span class="vip">{{ 'choose_a_plan.vip' | translate }}</span>
          }
        </div>
      </div>
      @if(!this.psychologistService.psychologist()?.vip) {
        <span class="warning">{{ 'choose_a_plan.price_adjust' | translate}}</span>
      }
      <app-button
        [buttonLabel]="'buttons.professional' | translate"
        (click)="choosePlan(PLANS.PROFESSIONAL.code)"
      ></app-button>
      <span class="warning">{{ 'choose_a_plan.microcopy'  | translate }}</span>
    </div>  
  </div>
}
